import AICreateForm from '@/modules/aiChat/createForm/AICreateForm'
import { createNewConversation } from '@/redux/slices/aiChatSlice'
import { useAppDispatch, useAppSelector } from '@/redux/store'
import { UserRole } from '@/typings/domain'
import { nanoid } from '@reduxjs/toolkit'
import { useEffect, useState } from 'react'
import { Text, View } from 'react-native'

export default function AICreateFormPage() {
  const dispatch = useAppDispatch()
  const [conversationId] = useState(() => nanoid())
  const currentUserLoaded = useAppSelector(state => state.currentUser.loaded)
  const currentUser = useAppSelector(state => state.currentUser.user)

  useEffect(() => {
    dispatch(createNewConversation({ id: conversationId }))
  }, [conversationId, dispatch])

  if (!currentUserLoaded || !currentUser) {
    return null
  }

  if (currentUser.role === UserRole.Outworker) {
    return (
      <View className="flex-1 items-center justify-center p-4">
        <Text className="text-gray-500 text-center">企业查看员无权创建表单</Text>
      </View>
    )
  }

  return <AICreateForm conversationId={conversationId} />
}
